module.exports = __webpack_public_path__ + "static/media/check-success.f0e298e6.svg";